// Import from 'moment-timezone' to avoid versioning clashes
// https://momentjs.com/timezone/docs/#/use-it/node-js/
import moment from 'moment-timezone'
window.moment = moment;
